/**
 * Which app store to offer on this device: `"android"` for an Android phone,
 * `"ios"` for an iPhone or iPod, and `"other"` for everything else.
 *
 * Tablets are `"other"`: Android tablets omit `Mobile` from the user agent and
 * iPadOS reports itself as a Mac, so neither is identified as a phone.
 *
 * @param {Navigator|undefined} [nav]
 * @returns {"android"|"ios"|"other"}
 */
export const storePlatform = (nav = globalThis.navigator) => {
  const userAgent = nav?.userAgent ?? "";
  const hints = nav?.userAgentData;

  // Either signal is enough: an emulated device changes the user agent string
  // without updating the client hints.
  const androidPhone =
    (hints?.platform === "Android" && hints?.mobile === true) ||
    (/\bAndroid\b/.test(userAgent) && /\bMobile\b/.test(userAgent));
  if (androidPhone) return "android";

  if (/\b(iPhone|iPod)\b/.test(userAgent)) return "ios";

  return "other";
};
